<template>
  <div class="dashboard">
    <download-csv :data="csvDataX" ref="csv" :name="fileNameX" v-show="false">
      <div></div>
    </download-csv>
    <div class="content">
      <div class="row">
        <div class="search">
          <div class="search-export-container">
            <div class="search-bar">
              <search-field @search="searchText = $event" placeholder="Enter Name" />
            </div>
            <div>
              <button class="btn-flat blue white-text" style="margin-right:5px;" @click="downloadPDF()">
                <i class="left material-icons-outlined">file_download</i>
                Download PDF(S)
              </button>
              <a class="dropdown-trigger btn-flat blue white-text" ref="export-dropdown" @click.prevent
                data-target="export-dropdown">
                <i class="left material-icons-outlined">file_download</i>
                Export CSV</a>

              <ul id="export-dropdown" class="dropdown-content">
                <li>
                  <a @click.prevent="$_generateNonVerified()">Non Verified Users</a>
                </li>
                <li>
                  <a @click.prevent="$_generateVerifiedUsers()">Home Profile Users</a>
                </li>
                <li>
                  <a @click.prevent="$_generateSubmittedUsers()">Submitted Entry Users</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-options">
            <div class="filter select">
              <label style="font-weight:600">School</label>
              <select class="browser-default" v-model="filterSchool">
                <option value="" selected>All</option>
                <option :value="school.text" v-for="school in schools" :key="school.value">{{ school.text }}</option>
              </select>
            </div>
            <div class="filter select">
              <label style="font-weight:600">Form</label>
              <select class="browser-default" v-model="filterForm">
                <option value="" selected>All</option>
                <option :value="form" v-for="form in forms" :key="form">
                  Form {{ form }}</option>
              </select>
            </div>
            <div class="filter select">
              <label style="font-weight:600">Verified Users</label>
              <select class="browser-default" v-model="verifiedAccounts">
                <option value="all">All</option>
                <option :value="true">Verified</option>
                <option :value="false">Non-Verified</option>
              </select>
            </div>
            <div class="filter select">
              <label style="font-weight:600">Submitted Entry</label>
              <select class="browser-default" v-model="submittedEntry">
                <option value="all">All</option>
                <option :value="true">Submitted</option>
                <option :value="false">Non-Submitted</option>
              </select>
            </div>
          </div>

          <div class="selected-rows left">
            {{ selectedRows.length }} of
            {{
              listPagination.count > listPaginationX.totalResults
              ? listPaginationX.totalResults
              : listPagination.count
            }}
            Selected
          </div>

          <div class="results right">
            <!--  <span>{{ listPaginationX.totalResults }}</span> of -->
            <span>{{
              listPagination.page === 1
              ? listPagination.page + ` - ` + listPagination.count
              : listPagination.page > 1
                ? listPagination.count * (listPagination.page - 1) + ` - ` + ((listPagination.count * listPagination.page) >
                  listPaginationX.total ? listPaginationX.total : listPagination.count * listPagination.page)
                : ''
            }}</span> of
            <span>{{ listPaginationX.total }}</span>
          </div>

          <div class="clear">

          </div>
        </div>
      </div>
      <div class="col s12 uses-table-container responsive-table">
        <table>
          <thead>
            <tr>
              <th>
                <label>
                  <input type="checkbox" class="filled-in" @change="toggleSelectedRows" :checked="listPaginationX.totalResults &&
                    selectedRows.length === listPaginationX.totalResults
                    " />
                  <span></span>
                </label>
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>School</th>
              <th>Form</th>
              <th>Last Login</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <user-item v-for="user in listPaginationX.results" :key="user.id" :data-user="user" @open="openModal"
              @update="updateSelectedRows" :data-selected-rows="selectedRows"></user-item>
          </tbody>
        </table>
      </div>

      <div class="pag-container">
        <ul class="pagination">
          <li class="waves-effect" :class="{ disabled: listPaginationX.page <= 1 }">
            <a @click.prevent="() => (listPaginationX.page > 1 ? listPagination.page-- : false)
              "><i class="material-icons">chevron_left</i></a>
          </li>
          <li :class="{ active: page === listPaginationX.page }" v-for="page in listPaginationX.totalPages" :key="page">
            <a @click.prevent="listPaginationX = page">{{ page }}</a>
          </li>
          <li class="waves-effect" :class="{
            disabled: listPaginationX.page >= listPaginationX.totalPages,
          }">
            <a href="#!" @click.prevent="() =>
                listPaginationX.page < listPaginationX.totalPages
                  ? listPagination.page++
                  : false
              "><i class="material-icons">chevron_right</i></a>
          </li>
        </ul>
        <div class="results">
          <!--  <span>{{ listPaginationX.totalResults }}</span> of -->
          <span>{{
            listPagination.page === 1
            ? listPagination.page + ` - ` + listPagination.count
            : listPagination.page > 1
              ? listPagination.count * (listPagination.page - 1) + ` - ` + ((listPagination.count * listPagination.page) >
                listPaginationX.total ? listPaginationX.total : listPagination.count * listPagination.page)
              : ''
          }}</span> of
          <span>{{ listPaginationX.total }}</span>
        </div>
      </div>
    </div>

    <loading-progress data-position="fixed" v-if="!ready || isProcessing" :data-message="loadingMessage" />
    <message-modal v-if="showModal" :data-email="selectedEmails" @close="closeModal()" />
  </div>
</template>
<script>
import searchField from "@/components/searchField.component";
import { getCookie } from "@/common/util";
import userItem from "@/components/admin/userItem.component";
import schools from "@/JsonSchemas/schoolList";
import axios from "axios";
import store from "@/store";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import equal from "fast-deep-equal/es6";
import {
  getAuthenticatedUser,
  createUserPDF,
  generateZip,
} from "@/api/user.api";
import { mapGetters } from "vuex";
import * as util from "@/common/util";

import M from "materialize-css";
import MessageModal from "@/components/admin/messageModal.vue";

const getUserProfiles = async (pagination) => {
  let token = getCookie("token");
  let url = `https://api.sldb.lc/wp-json/wp/v2/profiles?per_page=${pagination.per_page}&page=${pagination.page}&context=edit`;
  return axios.get(url, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

const getAllSurveys = async (pagination, token) => {
  let url = `https://api.sldb.lc/wp-json/wp/v2/surveys?per_page=${pagination.per_page}&page=${pagination.page}&roles=subscriber&context=edit`;
  return axios.get(url, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};
const getUsers = async (pagination, token) => {
  /* let url = `https://api.sldb.lc/wp-json/wp/v2/users?per_page=${pagination.per_page}&page=${pagination.page}&roles=subscriber&context=edit`; */
  let url = `https://api.sldb.lc/wp-json/wp/v2/users?per_page=${pagination.per_page}&page=${pagination.page}&roles=subscriber&context=edit`;
  return axios.get(url, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};
export default {
  name: "AdminUsers",
  components: {
    searchField,
    userItem,
    MessageModal,
  },
  data() {
    return {
      loadingMessage: "Loading please wait. This may take a while.",
      schools,
      verifiedAccounts: "all",
      completedAccounts: false,
      submittedEntry: "all",
      filterSchool: "",
      filterForm: "",
      searchText: "",
      ready: false,
      selectedEmails: "",
      showModal: false,
      surveysData: {
        page: 1,
        totalPages: 0,
        totalItems: 0,
        per_page: 100,
        data: [],
      },
      forms: [1, 2, 3, 4, 5],
      // users: [],
      profilesData: {
        page: 1,
        totalPages: 0,
        totalItems: 0,
        per_page: 100,
        data: [],
      },
      fileName: "data.csv",
      csvData: [
        {
          hello: "hello",
          world: "world",
        },
      ],
      listPagination: {
        count: 50,
        page: 1,
        totalPages: 0,
      },
      page: 1,
      totalPages: 0,
      totalItems: 0,
      per_page: 100,

      exportDropdown: {
        instance: null,
        options: {
          constrainWidth: false,
          coverTrigger: false,
          alignment: "right",
        },
      },
      selectedRows: [],
      isProcessing: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const allowedRoles = ["administrator", "editor", "competition_admin"];
    try {
      const token = Cookies.get("token");
      // Fetch user roles here ?
      if (!store.state.User.user && token) {
        const { data } = await getAuthenticatedUser({ token });
        store.commit("User/UPDATE_USER", data);
      }
      const userRoles = store.state.User.user.roles;

      if (!userRoles) throw "not-allowed";

      const isAllowed = userRoles.reduce((result, item) => {
        if (!result) {
          result = allowedRoles.some((role) => role === item);
        }
        return result;
      }, false);

      if (!isAllowed) throw "not-allowed";
      next();
    } catch (error) {
      next({ name: "Home" });
    }
  },
  created() {
    this.loadedUsers &&
      this.loadedProfiles &&
      this.loadedProfiles &&
      (this.ready = true);
  },
  beforeDestroy() {
    this.exportDropdown.instance && this.exportDropdown.instance.destroy();
  },
  mounted() {
    this.$_getFiltersFromRoute();
    this.initDropdown();

    if (!this.loadedUsers) {
      this.viewUser({
        page: this.page,
        per_page: this.per_page,
      });
    }
    if (!this.loadedProfiles) {
      this.viewProfiles({
        page: this.page,
        per_page: this.per_page,
      });
    }
    if (!this.loadedSurveys) {
      this.viewSurveys({
        page: this.surveysData.page,
        per_page: this.surveysData.per_page,
      });
    }
  },
  watch: {

    filterSchool(nV) {
      // this.$_updateQuery({ school: nV });
      this.listPaginationX = 1
    },
    filterForm(nV) {
      // this.$_updateQuery({ form: nV });
      this.listPaginationX = 1
    },
    verifiedAccounts() {
      this.listPaginationX = 1
    },
    submittedEntry() {
      this.listPaginationX = 1
    },
    "listPaginationX.page"() {
      window.scrollTo({
        top: 0,
      });
    },
  },
  computed: {
    ...mapGetters({
      loadedUsers: "Admin/loadedUsers",
      loadedProfiles: "Admin/loadedProfiles",
      loadedSurveys: "Admin/loadedSurveys",
    }),

    listPaginationX: {
      get() {
        const start =
          this.listPagination.count * (this.listPagination.page - 1);
        const end = start + this.listPagination.count;

        const val = this.filteredList.slice(start, end);
        return {
          page: this.listPagination.page,
          totalPages: Math.ceil(
            this.filteredList.length / this.listPagination.count
          ),
          total: this.allUserProfiles.length,
          totalResults: this.filteredList.length,
          results: val,
        };
      },
      set(val) {
        this.listPagination.page = val;
      },
    },
    users: {
      get() {
        return this.$store.state.Admin.users;
      },
      set(val) {
        this.$store.commit("Admin/SET_USERS", val);
      },
    },
    profiles: {
      get() {
        return this.$store.state.Admin.profiles;
      },
      set(val) {
        this.$store.commit("Admin/SET_PROFILES", val);
      },
    },
    surveys: {
      get() {
        return this.$store.state.Admin.surveys;
      },
      set(val) {
        this.$store.commit("Admin/SET_SURVEYS", val);
      },
    },
    fileNameX() {
      if (!this.fileName) return "data.csv";
      return this.fileName;
    },
    csvDataX() {
      if (!this.csvData) return [];
      return this.csvData;
    },
    allUserProfiles() {
      let results = this.users.map((userObj) => {
        let matchedProfile = this.profiles.find(
          (ele) => userObj.id === ele.author
        );

        return {
          ...userObj,
          acf: (matchedProfile && matchedProfile.acf) || { verified: false },
          profile: matchedProfile && matchedProfile.id,
          profile_slug: matchedProfile && matchedProfile.slug,
        };
      });

      return results;
    },
    nonVerifiedUsers() {
      return this.allUserProfiles.filter((x) => !x.acf.verified);
    },

    verifiedUsers() {
      return this.allUserProfiles.filter((x) => x.acf.verified);
    },
    filteredList() {
      let results = this.allUserProfiles.filter(({ name, acf }) => {
        const submittedCheck = () => {
          if (this.submittedEntry === "all") return true;
          const competitionEntry = acf.competition_entry
            ? JSON.parse(acf.competition_entry)
            : false;

          const val = competitionEntry && competitionEntry.submitted;

          return val === this.submittedEntry;
        };

        const verified =
          this.verifiedAccounts === "all"
            ? true
            : acf.verified === this.verifiedAccounts;

        return (
          name.toLowerCase().includes(this.searchText.toLowerCase()) &&
          verified &&
          submittedCheck()
        );
      });
      if (this.filterSchool) {
        results = results.filter(({ acf }) => {
          const competitionEntry = acf.competition_entry
            ? JSON.parse(acf.competition_entry)
            : false;

          if (competitionEntry) {
            return (
              competitionEntry.name_of_school &&
              competitionEntry.name_of_school
                .toLowerCase()
                .includes(this.filterSchool.toLowerCase())
            );
          } else {
            return (
              acf.school &&
              acf.school.toLowerCase().includes(this.filterSchool.toLowerCase())
            );
          }
        });
      }

      if (this.filterForm) {
        results = results.filter((user) => {
          const { acf } = user;

          const info =
            acf && acf.competition_entry && JSON.parse(acf.competition_entry);

          if (info) {
            const { school_form } = info;
            return school_form == this.filterForm;
          }
        });
      }
      return results;
    },
    userSchool() {
      const { school } = this.$store.state.User.user;
      return school;
    },
    isAdmin() {
      if (!this.$store.state.User.user) return false;
      const allowedRoles = ["administrator"];
      const userRoles = this.$store.state.User.user.roles;
      if (!userRoles) return false;

      const isAllowed = userRoles.reduce((result, item) => {
        if (!result) {
          result = allowedRoles.some((role) => role === item);
        }
        return result;
      }, false);

      return isAllowed;
    },
    verifiedCount: {
      get() {
        return this.profilesData.data.length > 0
          ? this.users.filter((x) => x.profile && x.profile.verified)
          : "";
      },
    },
  },

  methods: {
    openModal(email) {
      this.showModal = true;
      if (this.selectedRows.length) {
        this.selectedEmails = this.selectedRows.reduce((emails, userId) => {
          const user = this.allUserProfiles.find(({ id }) => id == userId);
          user && emails.push(user.email);
          return emails;
        }, []);

        return;
      }
      this.selectedEmails = email;
    },
    closeModal() {
      this.showModal = false;
      this.selectedEmails = "";
    },

    toggleSelectedRows({ target }) {
      const { checked } = target;

      if (!checked) {
        this.selectedRows = [];
        return;
      }

      this.selectedRows = this.listPaginationX.results.map(({ id }) => id);
    },
    updateSelectedRows({ id, checked }) {
      if (checked) {
        this.selectedRows.push(id);
        return;
      }

      this.selectedRows = this.selectedRows.filter((item) => item !== id);
    },
    initDropdown() {
      this.exportDropdown.instance = M.Dropdown.init(
        this.$refs["export-dropdown"],
        this.exportDropdown.options
      );
    },
    download(url, filename) {
      fetch(url).then(function (t) {
        return t.blob().then((b) => {
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
        });
      });
    },
    async downloadPDF() {
      if (this.isProcessing) return;
      this.loadingMessage = "Downloading";
      this.isProcessing = true;

      const payload = { school: false };
      if (this.filterSchool) {
        const val = schools.find(({ text }) => text === this.filterSchool);
        payload.school = val.value;
      }

      try {
        // await generateZip(payload);
        await this.download(
          `${util.APP_URL}/downloads/${payload.school || "pdfs"}.zip`,
          `${payload.school || "pdfs"}.zip`
        );
        this.isProcessing = false;
      } catch (error) {
        this.isProcessing = false;
        util.toastMessage("Failed to download PDFs");
      }
    },
    async generatePDF() {
      if (this.isProcessing) return;
      if (!this.selectedRows.length) {
        util.toastMessage("No User(s) selected.");
        return;
      }

      this.isProcessing = true;

      let generatePdfs = [];

      for (const idx of this.selectedRows) {
        const user = this.allUserProfiles.find(({ id, acf }) => {
          const competitionEntry =
            acf.competition_entry && JSON.parse(acf.competition_entry);

          if (
            id == idx &&
            competitionEntry &&
            competitionEntry.submitted/*  &&
            !acf.pdf */
          )
            return true;
        });

        user && generatePdfs.push(user);
      }

      if (!generatePdfs.length) {
        util.toastMessage("All PDF Generated");
        this.isProcessing = false;
        return;
      }

      const createPDF = async (payload) => {
        return createUserPDF(payload);
      };

      // Generate pdfs

      const arr = [];

      generatePdfs.map((user) => {
        const { profile_slug, id, profile, acf } = user;
        const competitionEntry = JSON.parse(acf.competition_entry);
        if (!profile_slug || !id) return;

        const payload = {
          slug: profile_slug,
          school: "other",
          form: competitionEntry.school_form,
          profile,
          id,
        };

        const school = schools.find(
          ({ text }) => text === competitionEntry.name_of_school
        );

        if (school) payload.school = school.value;

        arr.push(createPDF(payload));
      });

      try {
        const results = await Promise.allSettled(arr);

        this.isProcessing = false;
        util.toastMessage("All PDF Generated");
      } catch (error) {
        this.isProcessing = false;
      }
    },

    $_generateNonVerified() {
      const exportVal = this.nonVerifiedUsers.reduce((result, user) => {
        let userObj = {};

        const {
          email,
          first_name,
          last_name,
          username,
          registered_date,
          acf,
        } = user;

        userObj = {
          "First Name": first_name,
          "Last Name": last_name,
          Username: username,
          Email: email,
          School: "",
          "Registration Date": dayjs(registered_date).format("MMM DD, YYYY"),
        };

        acf.school && (userObj.School = acf.school);
        result.push(userObj);

        return result;
      }, []);

      this.fileName = "non-verified-users.csv";
      this.csvData = exportVal;

      setTimeout(() => {
        this.$refs.csv.generate();
      });
    },
    $_generateSubmittedUsers() {
      const exportVal = this.verifiedUsers.reduce((result, user) => {
        let userObj = {};

        const {
          email,
          first_name,
          last_name,
          username,
          registered_date,
          acf,
        } = user;

        userObj = {
          "First Name": first_name,
          "Last Name": last_name,
          Username: username,
          Email: email,
          School: "",
          "Registration Date": dayjs(registered_date).format("MMM DD, YYYY"),
        };

        const { school, competition_entry } = acf;

        school && (userObj.School = school);

        const competitionEntry =
          competition_entry && JSON.parse(competition_entry);

        if (competitionEntry) {
          const { submitted } = competitionEntry;
          submitted && result.push(userObj);
        }

        return result;
      }, []);

      this.fileName = "submitted-verified-users.csv";
      this.csvData = exportVal;

      setTimeout(() => {
        this.$refs.csv.generate();
      });
    },
    $_generateVerifiedUsers() {
      const exportVal = this.verifiedUsers.reduce((result, user) => {
        let userObj = {};

        const {
          email,
          first_name,
          last_name,
          username,
          registered_date,
          acf,
        } = user;

        userObj = {
          "First Name": first_name,
          "Last Name": last_name,
          Username: username,
          Email: email,
          School: "",
          "Registration Date": dayjs(registered_date).format("MMM DD, YYYY"),
        };

        const { school, home_profile } = acf;

        school && (userObj.School = school);

        let percentage = this.$_homeProfilePercentage(home_profile);

        userObj["Home Profile (%)"] = `${percentage}`;

        result.push(userObj);

        return result;
      }, []);

      this.fileName = "home-profile-verified-users.csv";
      this.csvData = exportVal;

      setTimeout(() => {
        this.$refs.csv.generate();
      });
    },
    $_homeProfilePercentage(val) {
      const typeValCheck = (x) => {
        let condition_1 =
          (x && Array.isArray(x) && x.length > 0) ||
            (x && !Array.isArray(x) & (x !== "") && x !== null)
            ? true
            : false;

        return condition_1;
      };
      let hp = val !== "" && val ? JSON.parse(val) : false;
      return hp
        ? (
          (Object.values(hp).filter((x) => typeValCheck(x)).length /
            Object.values(hp).length) *
          100
        ).toFixed(0)
        : 0;
    },
    $_updateQuery(val) {
      if (!this.ready) return;

      const routeQuery = { ...this.$route.query };
      Object.assign(routeQuery, val);
      for (const key in routeQuery) {
        if (routeQuery[key] === "") {
          delete routeQuery[key];
        }
      }

      // No need to update route query if there isn't a change
      if (equal(routeQuery, this.$route.query)) return;
      this.$router.replace({ query: { ...routeQuery } });
    },
    $_resetFilters() {
      this.filterSchool = "";
      this.searchText = "";
      this.filterForm = "";
      this.submitted = "";
      this.verified = "";
    },
    $_getFiltersFromRoute() {
      const { school, form, submitted, verified } = this.$route.query;
      !!submitted && (this.submittedEntry = submitted === "true");
      !!verified && (this.verifiedAccounts = verified === "true");

      school && (this.filterSchool = school);

      form && (this.filterForm = form);
    },
    mapProfile(payload) {
      let record = this.users.find((x) => x.id === payload.id);
      record["profile"] = payload.data;
    },
    fetchMore() {
      this.viewUser(
        {
          page: this.page,
          per_page: this.per_page,
        },
        true
      );
    },
    fetchMorePorfiles() {
      this.viewProfiles(
        {
          page: this.profilesData.page,
          per_page: this.profilesData.per_page,
        },
        true
      );
    },
    fetchMoreSurveys() {
      this.viewSurveys(
        {
          page: this.surveysData.page,
          per_page: this.surveysData.per_page,
        },
        true
      );
    },
    viewUser(
      pagination = { page: this.page, per_page: this.per_page },
      more = false
    ) {
      let token = getCookie("token");

      getUsers(pagination, token)
        .then((x) => {
          this.users = x.data;
          this.totalItems = x.headers["x-wp-total"];
          this.totalPages = x.headers["x-wp-totalpages"];
          this.$store.commit("Admin/SET_TOTAL_USERS", this.totalItems);

          if (this.users.length < this.totalItems) {
            this.page += 1;
            this.fetchMore();
          }
          if (parseInt(this.totalItems) === this.users.length)
            this.ready = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewSurveys(
      pagination = {
        page: this.surveysData.page,
        per_page: this.surveysData.per_page,
      },
      more = false
    ) {
      let token = getCookie("token");
      getAllSurveys(pagination, token)
        .then((x) => {
          this.surveys = x.data;
          this.surveysData.totalItems = x.headers["x-wp-total"];
          this.surveysData.totalPages = x.headers["x-wp-totalpages"];
          this.$store.commit(
            "Admin/SET_TOTAL_SURVEYS",
            this.surveysData.totalItems
          );

          if (this.surveys.length < this.surveysData.totalItems) {
            this.surveysData.page += 1;
            this.fetchMoreSurveys();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewProfiles(
      pagination = {
        page: this.profilesData.page,
        per_page: this.profilesData.per_page,
      },
      more = false
    ) {
      getUserProfiles(pagination)
        .then((x) => {
          this.profiles = x.data;

          this.profilesData.totalItems = x.headers["x-wp-total"];
          this.profilesData.totalPages = x.headers["x-wp-totalpages"];
          this.$store.commit(
            "Admin/SET_TOTAL_PROFILES",
            this.profilesData.totalItems
          );
          if (this.profiles.length < this.profilesData.totalItems) {
            this.profilesData.page += 1;
            this.fetchMorePorfiles();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
thead {
  tr {
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.08),
      0 3px 1px -2px rgba(0, 0, 0, 0.06), 0 1px 5px 0 rgba(0, 0, 0, 0.099);
  }
}

tr {
  th {
    font-weight: 600 !important;

    align-self: center;

    &:first-of-type {
      justify-self: center;

      span {
        display: inline !important;
      }
    }
  }

  display: grid;
  grid-template-columns: 50px 1fr 1fr 2fr 120px 120px 120px;
}

.btn-download {
  margin: 10px 0;
}

h4 {
  font-size: 26px;
  font-weight: 500;
}

.content {
  padding: 20px 10px;
  max-width: 1200px;
  margin: 0 auto;

  // margin-bottom: 50px;
  .search {
    width: 100%;
    padding: 12px 5px;

    .search-export-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .search-bar {
        width: 400px;
      }
    }

    .selected-rows {
      margin-top: 20px;
    }

    .filter-options {
      display: grid;
      grid-template-columns: 250px 130px 150px 170px;

      .filter {
        padding: 0 10px;

        &.select {
          select {
            margin-top: 8px;
          }
        }

        &.radio-group {
          display: grid;
          grid-template-rows: auto auto auto;

          .title {
            font-weight: 600;
            margin-bottom: 8px;

            label {
              display: block;
            }
          }
        }

        &:first-of-type {
          padding-left: 0;
        }
      }
    }
  }

  .collection {
    padding-top: 30px;
    padding-bottom: 75px;
    margin-bottom: 0 !important;
    margin-top: 154px;
    overflow: visible;

    border: none;

    .collection-item {
      margin: 12px 0;
      border-radius: 6px;
    }
  }
}

.topNav {
  justify-content: space-between;
}

.count {
  text-align: right;
  padding: 45px 15px 0 0;
}

.pag-container {
  position: relative;
  text-align: center;
  padding: 10px;

  li {
    cursor: pointer;
  }

  .results {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: 18px;
  }
}
</style>
